<script lang="ts">
  import { get } from 'svelte/store';
  import { page } from '$app/state';
  import { isDemoSession } from '$lib/stores/auth.js';
  import { leaveDemoMode, resetDemoMode } from '$lib/demo.js';
  import { toast } from '$lib/stores/toast.js';
  import { FlaskConical } from 'lucide-svelte';

  let isDemo = $state(get(isDemoSession));
  $effect(() => isDemoSession.subscribe((v) => { isDemo = v; }));

  // The optional provider simulator has its own explicit demo chrome.
  let show = $derived(isDemo && !page.url.pathname.startsWith('/demo/akahu'));
  let action = $state<'leave' | 'reset' | null>(null);

  async function leave() {
    if (action) return;
    action = 'leave';
    try {
      await leaveDemoMode();
    } catch (e) {
      action = null;
      toast.error(e instanceof Error ? e.message : 'Could not leave the demo');
    }
  }

  async function reset() {
    if (action) return;
    action = 'reset';
    try {
      await resetDemoMode();
    } catch (e) {
      action = null;
      toast.error(e instanceof Error ? e.message : 'Could not reset the demo');
    }
  }
</script>

{#if show}
  <div class="sticky top-0 z-[60] flex flex-wrap items-center justify-center gap-2 bg-amber-500 px-4 py-1.5 text-xs font-semibold text-amber-950 shadow-sm">
    <FlaskConical class="h-3.5 w-3.5 shrink-0" strokeWidth={2} />
    <span>LIVE DEMO — fictional data. No bank is connected and no real money can move.</span>
    <button
      type="button"
      onclick={reset}
      disabled={action !== null}
      class="ml-1 rounded-full bg-amber-950/15 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide transition hover:bg-amber-950/25 disabled:opacity-60"
    >
      {action === 'reset' ? 'Resetting…' : 'Reset'}
    </button>
    <button
      type="button"
      onclick={leave}
      disabled={action !== null}
      class="rounded-full bg-amber-950/15 px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide transition hover:bg-amber-950/25 disabled:opacity-60"
    >
      {action === 'leave' ? 'Leaving…' : 'Leave demo'}
    </button>
  </div>
{/if}
